export const GUTTER = '1.5rem';
export const SMALL_GUTTER = '.75rem';
export const WIDTH = '1280px';
export const TITLE = 'LP VENT';
export const LARGE_FONT = '1.125em';
export const TEXT = '#2a2a2a';
export const TEXT_WHITE = '#E8E9EB';
export const TEXT_WHITE_HOVER = '#E0DFD5';
export const BACKGROUND = '#313638';
export const BACKGROUND_WHITE = '#fff';
export const ACCENT_LIGHT = '#FAFAFF';



// WEBPACK FOOTER //
// constants/theme.js